import { type ReactNode } from 'react';
import { Link } from '~/components/Link/Link';
import styles from './Breadcrumb.module.css';

function BreadcrumbLink({ to, children }: { to: string; children: ReactNode }) {
  return (
    <span className={styles.item}>
      <Link to={to}>{children}</Link>
    </span>
  );
}

function BreadcrumbCurrent({ children }: { children: ReactNode }) {
  return (
    <span className={styles.item}>
      <span className={styles.current}>{children}</span>
    </span>
  );
}

function BreadcrumbRoot({ children }: { children: ReactNode }) {
  return <div className={styles.breadcrumb}>{children}</div>;
}

export const Breadcrumb = Object.assign(BreadcrumbRoot, {
  Link: BreadcrumbLink,
  Current: BreadcrumbCurrent,
});
